import 'a11y-dialog';
import getCookie from "./csrftoken";


document.addEventListener("DOMContentLoaded", function(event) {
    console.log('Project page JS initialized.');

    var auto_publish_checkbox = document.getElementById('auto_publish_checkbox') ?? null;
    if (auto_publish_checkbox) {
        // access data property from the element
        if (auto_publish_checkbox.dataset.state === 'moderation') {
            var submit_mod_button = document.getElementById('submit_mod_button');
            var submit_mod_autopub_button = document.getElementById('submit_mod_autopub_button');

            auto_publish_checkbox.addEventListener('change', function () {
                if (auto_publish_checkbox.checked) {
                    submit_mod_button.style.display = 'none';
                    submit_mod_autopub_button.style.display = 'block';
                } else {
                    submit_mod_button.style.display = 'block';
                    submit_mod_autopub_button.style.display = 'none';
                }
            });
        }

        if (auto_publish_checkbox.dataset.state === 'rejected' || auto_publish_checkbox.dataset.state === 'awaiting-moderation') {
            auto_publish_checkbox.addEventListener('change', function () {
                // do a CSRF request to update the auto publish setting
                let xhr = new XMLHttpRequest();
                let csrftoken = getCookie('csrftoken');

                xhr.open('get', auto_publish_checkbox.dataset.url, true);
                xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xhr.setRequestHeader("X-CSRFToken", csrftoken);
                xhr.onload = () => {
                    if (xhr.status !== 204) {
                        console.error('Error updating auto publish setting');
                    }
                };

                xhr.onerror = () => {
                    console.error('Network error while fetching suggestions.');
                };
                xhr.send();
            });
        }
    }
});